__turbopack_context__.v({
  "desktop": "PlasmicFooterTopNav-module__rZlj0W__desktop",
  "fb": "PlasmicFooterTopNav-module__rZlj0W__fb",
  "fb3": "PlasmicFooterTopNav-module__rZlj0W__fb3",
  "generaSolutions": "PlasmicFooterTopNav-module__rZlj0W__generaSolutions",
  "general": "PlasmicFooterTopNav-module__rZlj0W__general",
  "general3": "PlasmicFooterTopNav-module__rZlj0W__general3",
  "generalStayInTouch": "PlasmicFooterTopNav-module__rZlj0W__generalStayInTouch",
  "head": "PlasmicFooterTopNav-module__rZlj0W__head",
  "head11": "PlasmicFooterTopNav-module__rZlj0W__head11",
  "head12": "PlasmicFooterTopNav-module__rZlj0W__head12",
  "head15": "PlasmicFooterTopNav-module__rZlj0W__head15",
  "head2": "PlasmicFooterTopNav-module__rZlj0W__head2",
  "head5": "PlasmicFooterTopNav-module__rZlj0W__head5",
  "ig": "PlasmicFooterTopNav-module__rZlj0W__ig",
  "ig3": "PlasmicFooterTopNav-module__rZlj0W__ig3",
  "img__aP9Nl": "PlasmicFooterTopNav-module__rZlj0W__img__aP9Nl",
  "img__bVu6": "PlasmicFooterTopNav-module__rZlj0W__img__bVu6",
  "img__gfYvj": "PlasmicFooterTopNav-module__rZlj0W__img__gfYvj",
  "img__gzznv": "PlasmicFooterTopNav-module__rZlj0W__img__gzznv",
  "img__m5FG0": "PlasmicFooterTopNav-module__rZlj0W__img__m5FG0",
  "img__oDhLi": "PlasmicFooterTopNav-module__rZlj0W__img__oDhLi",
  "img__pg7AW": "PlasmicFooterTopNav-module__rZlj0W__img__pg7AW",
  "img__x9IAn": "PlasmicFooterTopNav-module__rZlj0W__img__x9IAn",
  "img__xWwyn": "PlasmicFooterTopNav-module__rZlj0W__img__xWwyn",
  "img__z6NSd": "PlasmicFooterTopNav-module__rZlj0W__img__z6NSd",
  "items": "PlasmicFooterTopNav-module__rZlj0W__items",
  "items12": "PlasmicFooterTopNav-module__rZlj0W__items12",
  "items4": "PlasmicFooterTopNav-module__rZlj0W__items4",
  "items9": "PlasmicFooterTopNav-module__rZlj0W__items9",
  "li": "PlasmicFooterTopNav-module__rZlj0W__li",
  "li3": "PlasmicFooterTopNav-module__rZlj0W__li3",
  "link": "PlasmicFooterTopNav-module__rZlj0W__link",
  "link116": "PlasmicFooterTopNav-module__rZlj0W__link116",
  "link117": "PlasmicFooterTopNav-module__rZlj0W__link117",
  "link118": "PlasmicFooterTopNav-module__rZlj0W__link118",
  "link2": "PlasmicFooterTopNav-module__rZlj0W__link2",
  "link3": "PlasmicFooterTopNav-module__rZlj0W__link3",
  "link36": "PlasmicFooterTopNav-module__rZlj0W__link36",
  "link37": "PlasmicFooterTopNav-module__rZlj0W__link37",
  "link38": "PlasmicFooterTopNav-module__rZlj0W__link38",
  "link4": "PlasmicFooterTopNav-module__rZlj0W__link4",
  "link5": "PlasmicFooterTopNav-module__rZlj0W__link5",
  "link6": "PlasmicFooterTopNav-module__rZlj0W__link6",
  "link81": "PlasmicFooterTopNav-module__rZlj0W__link81",
  "link82": "PlasmicFooterTopNav-module__rZlj0W__link82",
  "link83": "PlasmicFooterTopNav-module__rZlj0W__link83",
  "link84": "PlasmicFooterTopNav-module__rZlj0W__link84",
  "link85": "PlasmicFooterTopNav-module__rZlj0W__link85",
  "link86": "PlasmicFooterTopNav-module__rZlj0W__link86",
  "link___1Yu16": "PlasmicFooterTopNav-module__rZlj0W__link___1Yu16",
  "link__awqw": "PlasmicFooterTopNav-module__rZlj0W__link__awqw",
  "link__bmFdC": "PlasmicFooterTopNav-module__rZlj0W__link__bmFdC",
  "link__crPtM": "PlasmicFooterTopNav-module__rZlj0W__link__crPtM",
  "link__dbV5B": "PlasmicFooterTopNav-module__rZlj0W__link__dbV5B",
  "link__dv2C": "PlasmicFooterTopNav-module__rZlj0W__link__dv2C",
  "link__ea7W": "PlasmicFooterTopNav-module__rZlj0W__link__ea7W",
  "link__gCjg": "PlasmicFooterTopNav-module__rZlj0W__link__gCjg",
  "link__n8NP": "PlasmicFooterTopNav-module__rZlj0W__link__n8NP",
  "link__pSt52": "PlasmicFooterTopNav-module__rZlj0W__link__pSt52",
  "link__qdfO": "PlasmicFooterTopNav-module__rZlj0W__link__qdfO",
  "link__qg4C": "PlasmicFooterTopNav-module__rZlj0W__link__qg4C",
  "link__rEzin": "PlasmicFooterTopNav-module__rZlj0W__link__rEzin",
  "link__u4Eb": "PlasmicFooterTopNav-module__rZlj0W__link__u4Eb",
  "link__uh2YX": "PlasmicFooterTopNav-module__rZlj0W__link__uh2YX",
  "link__wvCUr": "PlasmicFooterTopNav-module__rZlj0W__link__wvCUr",
  "link__yzzJf": "PlasmicFooterTopNav-module__rZlj0W__link__yzzJf",
  "links": "PlasmicFooterTopNav-module__rZlj0W__links",
  "links3": "PlasmicFooterTopNav-module__rZlj0W__links3",
  "mobile": "PlasmicFooterTopNav-module__rZlj0W__mobile",
  "navs": "PlasmicFooterTopNav-module__rZlj0W__navs",
  "productsResources": "PlasmicFooterTopNav-module__rZlj0W__productsResources",
  "resources": "PlasmicFooterTopNav-module__rZlj0W__resources",
  "resources2": "PlasmicFooterTopNav-module__rZlj0W__resources2",
  "resources5": "PlasmicFooterTopNav-module__rZlj0W__resources5",
  "resources6": "PlasmicFooterTopNav-module__rZlj0W__resources6",
  "stayInTouch": "PlasmicFooterTopNav-module__rZlj0W__stayInTouch",
  "stayInTouch3": "PlasmicFooterTopNav-module__rZlj0W__stayInTouch3",
  "th": "PlasmicFooterTopNav-module__rZlj0W__th",
  "th3": "PlasmicFooterTopNav-module__rZlj0W__th3",
  "x": "PlasmicFooterTopNav-module__rZlj0W__x",
  "x3": "PlasmicFooterTopNav-module__rZlj0W__x3",
});
